export default {
  name: 'marking--xmlRequestDocument',
  apiService: 'shoes',
  apiPath: '/xml/document/load',
};